import {
  Box,
  BoxProps,
  ColorOptions,
  convertHexToRGBA,
  Icon,
  Image,
  Loader,
  ModalDialogNew,
  ModBox,
  Spacer,
  Text,
} from '@jfs/ui-new'
import { useNavigation, useRoute } from '@react-navigation/native'
import { VoiceBoxModule } from 'mportal-module'
import { useEffect, useState } from 'react'
import { Platform, ScrollView, ViewProps } from 'react-native'
import { QrStand } from '../../assets/images/svg/QrStand'
import Voice from '../../assets/images/svg/Voice'
import { ChatbotButton } from '../../comps/Chatbot'
import { HeaderLeft } from '../../comps/MobileCustomHeader/HeaderLeft'
import { SvgImage } from '../../comps/SvgImage'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { Colors, storeData } from '../../util/util'
import Toggle from '../NotificationSettings/Toggle'
import DeviceDetails from './DeviceDetails'
import { LANGUAGE_LIST_DATA, SelectLanguageModel } from './SelectLanguageModel'

export const monthlyCharge = (data) => {
  if (data) {
    return parseFloat(data).toFixed(2)
  } else {
    return data
  }
}

const VoiceBox = () => {
  const navigation = useNavigation()
  const params = useRoute()?.params ?? {}
  const { deviceid, index }: any = params
  // console.log('data', data)

  const {
    updateDeviceConfig,
    selectedLanguage,
    storedData,
    updateVoiceBoxInfo,
    fetchRecentsStats,
    device,
    pairRequests,
    mid,
  } = useStores((store) => ({
    updateDeviceConfig: store.voiceBoxes.updateDeviceConfig,
    selectedLanguage: store.voiceBoxes.getSelectedLanguage(deviceid),
    storedData: store.voiceBoxes.getVoiceBoxStoredData(),
    updateVoiceBoxInfo: store.voiceBoxes.updateVoiceBoxInfo,
    fetchRecentsStats: store.voiceBoxes.fetchRecentsStats,
    device: store.voiceBoxes.getVoiceBox(deviceid),
    pairRequests: store.voiceBoxes.pairRequests.slice(),
    mid: store.user.selectedMid,
  }))

  const pairRequestsCount = pairRequests.find((item) => item.dsn === deviceid)?.btDevices?.length ?? 0

  const [showModal, setShowModal] = useState(false)
  const [voiceAlertEnabled, setVoiceAlertEnabled] = useState(device?.voiceAlertsEnabled)
  const [showSelectLanguageModel, setShowSelectLanguageModel] = useState(false)

  // console.log('device data on params', device)

  const [updateDeviceConfigApi, { state }] = useLazyApiData(updateDeviceConfig)
  const [fetchRecentsStatsApi, { state: fetchRecentsStatsState }] = useLazyApiData(fetchRecentsStats)

  const headerLeft = () => {
    return (
      <Box backgroundColor={'TRANSPARENT'} flexDirection="row" justifyContent="center" alignItems={'center'} h={64}>
        <ModBox
          paddingLeft={25}
          paddingRight={10}
          top={Platform.OS === 'ios' ? -30 : 0}
          show={navigation?.canGoBack()}
          underlayColor={'TRANSPARENT'}
          testID="back-arrow"
          onPress={() => navigation?.goBack()}>
          <SvgImage imageName="HeaderArrowLeft" />
        </ModBox>
      </Box>
    )
  }

  navigation?.setOptions({
    title: '',
    headerTintColor: '#fff',
    headerBackVisible: true,
    headerLeft: Platform.OS === 'ios' ? headerLeft : () => <HeaderLeft />,
    headerShadowVisible: false,
    headerStyle: { backgroundColor: Colors.SECONDARY },
  })

  useEffect(() => {
    fetchRecentsStatsApi(deviceid)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (fetchRecentsStatsState === 'fulfilled') {
      //console.log('device updated data', device1)
    }
  }, [fetchRecentsStatsState])

  useEffect(() => {
    if (state === 'fulfilled') {
      const jsonStoredData = JSON.parse(storedData)
      jsonStoredData[deviceid].isVoiceAlertEnabled = voiceAlertEnabled
      storeData('voiceBoxInfo', jsonStoredData)
      jsonStoredData ? updateVoiceBoxInfo(JSON.stringify(jsonStoredData)) : updateVoiceBoxInfo('')
    } else if (state === 'rejected') {
      setVoiceAlertEnabled(!voiceAlertEnabled) // if rejected, reset it to prev state
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])

  const onValueChange = (val: boolean) => {
    setVoiceAlertEnabled(!voiceAlertEnabled)
    updateDeviceConfigApi(device.id, val, selectedLanguage)
  }

  const onSelectLanguagePress = () => {
    setShowSelectLanguageModel(true)
  }
  const handleRentalHistory = () => {
    navigation.navigate(Routes.RENTAL_HISTORY as never, { id: device.id, index: index } as never)
  }

  const handleManagePairedDevices = () => {
    VoiceBoxModule.showDeviceList(mid, deviceid)
  }

  const language = LANGUAGE_LIST_DATA.find((lang) => lang?.language?.includes(selectedLanguage))

  const title = device.title
  const deviceName = `${title.slice(0, 1).toUpperCase() + title.slice(1).toLowerCase()} ${index + 1}`

  return (
    <Box flex={1} backgroundColor="SECONDARY" position={'relative'}>
      <ModBox pl={25}>
        <Box flexDirection={'row'} alignItems="flex-start" justifyContent={'space-between'}>
          <Box width="80%" mb={Platform.OS === 'ios' ? 60 : 30}>
            <Spacer size={20} direction="vertical" />
            <Box flexDirection={'row'} align="center">
              <Text fontFamily={'JioType-Black'} fontSize={24} color="WHITE">
                {deviceName}
              </Text>
            </Box>
            <Spacer size={5} direction="vertical" />
            <Text fontFamily={'JioType-Medium'} fontSize={14} color={convertHexToRGBA('#fff', 70) as ColorOptions}>
              Serial No. {device?.details?.dsn}
            </Text>

            <Spacer size={24} direction="vertical" />
            <Box testID="view-more-details" onPress={() => setShowModal(true)} underlayColor="TRANSPARENT">
              <Text lineHeight={16} fontFamily={'JioType-Medium'} fontSize={12} color={Colors.PRIMARY_STORNG}>
                View More Details
              </Text>
            </Box>
          </Box>
          <Box width={Platform.OS === 'ios' ? '25%' : '30%'} alignItems="flex-end" position={'relative'}>
            {/* <Spacer size={10} direction="vertical" /> */}
            <Box justify="center">
              <Box zIndex={2} align="center" justify="center">
                <Image
                  source={Platform.OS === 'ios' ? require('../../assets/images/qr_scan.png') : 'qrscan'}
                  resizeMode="cover"
                  width={105}
                  height={105}
                />
                {/* <Image source={'qrscan'} resizeMode="cover" width={105} height={105} /> */}
              </Box>
              <Box zIndex={1} position="absolute" top={65} right={0}>
                <QrStand height={110} />
              </Box>
            </Box>
          </Box>
        </Box>
      </ModBox>
      <ScrollView
        style={{ backgroundColor: '#fff', ...styles.listWrapper, paddingTop: 0 }}
        showsVerticalScrollIndicator>
        <Spacer size={32} direction="vertical" />
        <Box alignItems="center" justifyContent={'space-between'} flexDirection={'row'}>
          <Text color={Colors.BLACK_14 as ColorOptions} fontSize={18} fontFamily="JioType-Bold">
            Bluetooth Users
          </Text>
        </Box>
        <Spacer size={16} direction="vertical" />
        <Box
          flexDirection={'row'}
          justifyContent="space-between"
          alignItems={'center'}
          borderWidth={1}
          borderColor={'#dfe0df' as ColorOptions}
          borderRadius={8}
          underlayColor="TRANSPARENT"
          onPress={handleManagePairedDevices}
          pv={14}
          ph={16}>
          <Box flexDirection={'row'} alignItems={'center'}>
            <SvgImage imageName="BluetoothSymbol" height={20} width={20} color={'#000'} />
            <Spacer size={15} direction="horizontal" />
            <Text color={Colors.BLACK_14 as ColorOptions} fontSize={14} fontFamily="JioType-Bold">
              Manage paired devices
            </Text>
          </Box>
          <Box flexDirection={'row'} alignItems="center">
            {pairRequestsCount > 0 && (
              <Box
                backgroundColor={'PRIMARY'}
                width={20}
                height={20}
                borderRadius={4}
                justifyContent="center"
                alignItems="center">
                <Text fontSize={12} fontFamily="JioType-Bold" color="WHITE">
                  {pairRequestsCount}
                </Text>
              </Box>
            )}
            <Spacer size={4} direction="horizontal" />
            <Icon id="ARROW_RIGHT" size={16} color={'PRIMARY'} />
          </Box>
        </Box>
        <Spacer size={32} direction="vertical" />
        <Box alignItems="center" justifyContent={'space-between'} flexDirection={'row'}>
          <Text color={Colors.BLACK_14 as ColorOptions} fontSize={18} fontFamily="JioType-Bold">
            Voice Alerts
          </Text>
          <Box flexDirection={'row'} align="center">
            <ModBox show={state === 'pending'}>
              <Loader type={'small'} />
            </ModBox>
            <Spacer size={5} direction="horizontal" />
            <ModBox disabled={state === 'pending'} opacity={state === 'pending' ? 0.6 : 1}>
              <Toggle
                disabled={state === 'pending'}
                onChange={(val) => onValueChange(val)}
                toggleValue={voiceAlertEnabled}
              />
            </ModBox>
          </Box>
        </Box>
        <Spacer size={16} direction="vertical" />
        <Box>
          <Box
            ph={12}
            pv={12}
            borderRadius={8}
            borderWidth={1}
            borderColor={'#dfe0df' as ColorOptions}
            // width={120}
            underlayColor="TRANSPARENT"
            testID="show-lang"
            onPress={onSelectLanguagePress}
            backgroundColor={'WHITE'}
            justifyContent="flex-start"
            alignItems={'center'}
            flexDirection={'row'}>
            <Voice color={Colors.PRIMARY} />
            <Spacer size={8} direction="horizontal" />
            <Text color={'PRIMARY'} fontSize={14} fontFamily="JioType-Bold">
              {language?.desc ?? device?.language}
            </Text>
            <Icon id={'ARROW_DOWN'} size={20} color={'PRIMARY'} />
            <Spacer size={3} direction="horizontal" />
            <Text lineHeight={21} color={'PRIMARY_GREY'} fontSize={12} fontFamily="JioType-Medium">
              {`(${LANGUAGE_LIST_DATA?.length} More Languages Available)`}
            </Text>
          </Box>
        </Box>
        <Spacer size={40} direction="vertical" />
        <Box>
          <Text lineHeight={24} color={Colors.BLACK_14 as ColorOptions} fontSize={18} fontFamily="JioType-Bold">
            Subscription Plan Details
          </Text>
          <Spacer size={14} direction="vertical" />
          <Box>
            <ModBox
              overflow="hidden"
              borderWidth={1}
              borderColor={'#dfe0df' as ColorOptions}
              borderRadius={10}
              backgroundColor={'#fffbf7' as ColorOptions}
              // flexDirection="row"
              // justifyContent={'space-between'}
              padding={24}>
              <ModBox
                zIndex={5}
                width={110}
                height={110}
                borderRadius={110}
                bg={convertHexToRGBA('#FA7D19', 10) as ColorOptions}
                align="center"
                left={-20}
                top={-20}
                position={'absolute'}
                justify="center">
                <Box {...styles.ripple1} zIndex={4} />
                <Box {...styles.ripple2} zIndex={4} />
                {/* <Box {...styles.ripple3} zIndex={4} /> */}
              </ModBox>
              <Box zIndex={8}>
                <Text fontFamily={'JioType-Medium'} fontSize={12} lineHeight={16} color={Colors.PRIMARY_GREY}>
                  Monthly Rental Plan
                </Text>
                <Spacer size={5} direction="vertical" />
                <Text fontFamily={'JioType-Bold'} fontSize={18} lineHeight={24} color={Colors.BLACK_14 as ColorOptions}>
                  ₹{monthlyCharge(device?.details?.monthlyCharges)}
                </Text>
              </Box>
              {/* <Box>
                <Box
                  bg={Colors.GREEN_SUCCESS_BG as ColorOptions}
                  pv={3}
                  ph={6}
                  align={'center'}
                  justify="center"
                  borderRadius={4}>
                  <Text fontFamily={'JioType-Bold'} color={'WHITE'} fontSize={12} lineHeight={16}>
                    PAID
                  </Text>
                </Box>
              </Box> */}
            </ModBox>
          </Box>
        </Box>
        <Spacer size={16} direction="vertical" />
        <Box
          mb={150}
          flexDirection={'row'}
          justifyContent="space-between"
          alignItems={'center'}
          borderWidth={1}
          borderColor={'#dfe0df' as ColorOptions}
          borderRadius={8}
          underlayColor="TRANSPARENT"
          testID="rental-history"
          onPress={handleRentalHistory}
          pv={14}
          ph={16}>
          <Box flexDirection={'row'} alignItems={'center'}>
            <SvgImage imageName="TransactionHistoryIcon" color={'#000'} />
            <Spacer size={15} direction="horizontal" />
            <Text color={Colors.BLACK_14 as ColorOptions} fontSize={14} fontFamily="JioType-Bold">
              Rental History
            </Text>
          </Box>
          <Box>
            <Icon id="ARROW_RIGHT" size={16} color={'PRIMARY'} />
          </Box>
        </Box>
        {/* <Spacer size={50} direction="vertical" /> */}
      </ScrollView>

      <SelectLanguageModel
        dsn={device?.id}
        show={showSelectLanguageModel}
        onDismiss={() => setShowSelectLanguageModel(false)}
      />
      <ModalDialogNew animate={true} show={showModal} type="bottom" backgroundColor="TRANSPARENT">
        <DeviceDetails data={device} onCancel={setShowModal} />
      </ModalDialogNew>
      <ModBox show={Platform.OS === 'android'}>
        <ChatbotButton />
      </ModBox>
    </Box>
  )
}
const styles = {
  listWrapper: {
    backgroundColor: '#fff',
    padding: 25,
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    width: '100%',
    zIndex: 4,
    // overflow: 'auto',
  } as ViewProps,
  ripple1: {
    backgroundColor: '#FA7D19' as ColorOptions,
    opacity: 0.1,
    width: 180,
    height: 180,
    borderRadius: 180,
    position: 'absolute',
  } as BoxProps,
  ripple2: {
    backgroundColor: '#FA7D19' as ColorOptions,
    opacity: 0.1,
    width: 250,
    height: 250,
    borderRadius: 250,
    position: 'absolute',
  } as BoxProps,
  ripple3: {
    backgroundColor: '#FA7D19' as ColorOptions,
    opacity: 0.1,
    width: 320,
    height: 320,
    borderRadius: 320,
    position: 'absolute',
  } as BoxProps,
}
export default VoiceBox
